import { render, staticRenderFns } from "./goods-swiper.vue?vue&type=template&id=e549189a&scoped=true"
import script from "./goods-swiper.vue?vue&type=script&lang=js"
export * from "./goods-swiper.vue?vue&type=script&lang=js"
import style0 from "./goods-swiper.vue?vue&type=style&index=0&id=e549189a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e549189a",
  null
  
)

export default component.exports